import PUZZLE_IMAGE from '../../../assets/images/puzzle/puzzle.png';
import badgeTypes from '../../../consts/loyalty/badgeTypes';
import milestoneTypes from '../../../consts/loyalty/milestoneTypes';
import routes from '../../../consts/routes';
import {strCode} from '../../../consts/strCode';
import {setCurrentBadge} from '../../../state/slice/loyalty';
import {hideAllModals} from '../../../state/slice/modal';
import {dispatch} from '../../../state/store';

const PUZZLE_CONFIG = {
    imageUrl: PUZZLE_IMAGE,
    badge: badgeTypes.QUEST_CHAMPION,
    milestoneType: milestoneTypes.DO_PUZZLE,
    completedSlide: {
        titleStrCode: strCode.CLUB_PAGE_QUEST_CHAMPION_PUZZLE_COMPLETE_TITLE,
        buttonStrCode: strCode.CLUB_PAGE_QUEST_CHAMPION_PUZZLE_COMPLETE_BUTTON,
        routeTo: routes.CLUB_BADGE,
        onClick: () => {
            dispatch(hideAllModals());
            dispatch(setCurrentBadge(badgeTypes.QUEST_CHAMPION));
        },
    },
};

export default PUZZLE_CONFIG;
